var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurve2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 76,
    viewBox: "0 0 162 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333333 3C0.333333 1.52724 1.52724 0.333336 3 0.333336C4.47276 0.333336 5.66667 1.52724 5.66667 3C5.66667 4.47276 4.47276 5.66666 3 5.66666C1.52724 5.66666 0.333333 4.47276 0.333333 3ZM157 72.5L162 70.1132V75.8868L157 73.5V72.5ZM84.5606 38C84.5606 36.5272 85.7545 35.3333 87.2272 35.3333C88.7 35.3333 89.8939 36.5272 89.8939 38C89.8939 39.4728 88.7 40.6667 87.2272 40.6667C85.7545 40.6667 84.5606 39.4728 84.5606 38ZM3 2.5H52.2273V3.5H3V2.5ZM122.227 72.5H157.5V73.5H122.227V72.5ZM87.7272 38C87.7272 57.0538 103.173 72.5 122.227 72.5V73.5C102.621 73.5 86.7272 57.6061 86.7272 38H87.7272ZM52.2273 2.5C71.8334 2.5 87.7272 18.3939 87.7272 38H86.7272C86.7272 18.9462 71.2811 3.5 52.2273 3.5V2.5Z",
    fill: "#252134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurve2);
export default __webpack_public_path__ + "static/media/curve-2.f338349c3909d19e1fd2a3d4dc0820e3.svg";
export { ForwardRef as ReactComponent };